import { EndUserPages } from '@aurora/shared-types/pages/enums';
import React from 'react';
import MessagePage from '../../../components/page/MessagePage/MessagePage';

/**
 * Idea Message Page
 *
 * @author Akash Goenka
 */
const IdeaMessagePage: React.FC<React.PropsWithChildren<unknown>> = () => {
  return <MessagePage pageId={EndUserPages.IdeaMessagePage} />;
};
export default IdeaMessagePage;
